import { initStore, PLAYER_TRANSACTIONS_SEARCH_TYPES } from '../../../common';
import { actions } from './actions';

export const playerTransactionsStore = (): void => {
	const initialState = {
		slice: 'PLAYER_TRANSACTIONS',
		transactions: [],
		isFilterValid: false,
		transactionsLoading: false,
		partners: [],
		games: [],
		devices: [],
		providers: [],
		transactionStatuses: [],
		transactionTypes: [],
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		columns: [],
		initialColumns: [],
		filtering: false,
		perPage: '10',
		filters: [
			{
				name: 'searchType',
				value: PLAYER_TRANSACTIONS_SEARCH_TYPES[0].value,
			},
		],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
